import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.List.IRequest;
type Response = Api.Core.ClaimJob.List.IResponse;
type Headers = Api.Core.ClaimJob.List.IHeaders;
const url = '/api/Claims/ClaimJob';
export default async function claimJobListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
